import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import moment from "moment";

// import TicketImg from "../assets/img/tickimg.png";
import GeneralChecks from "../../Assets/generalChecks.png";
import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import { Col, Row } from "antd";
import CarepoolImg from "../../Assets/Carepool_logo.png";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });

const styles = StyleSheet.create({
  body: {
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "30px",
    marginTop: "10px",
  },
  headerContainerCarePool: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
    marginTop: "10px",
  },
  tobecompletedContainer: {
    backgroundColor: "#E6E6E6",
    padding: "5px",
  },
  tobecompletedText: {
    color: "#FF4A86",
    fontSize: "9px",
    fontWeight: "200",
    fontStyle: "normal",
    marginLeft: "14px",
  },
  topfieldsmainContainer: {
    backgroundColor: "#F7F7F7",
    padding: "10px",
    height: "90px",
  },
  namefiledsContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  firstField: {
    width: "55%",
    marginRight: "20px",
  },
  secondfield: {
    width: "45%",
  },
  fieldBorder: {
    borderBottomWidth: 1,
    borderBottomColor: "#3F3F3F",
  },
  fieldBorder2: {
    borderBottomWidth: 1,
    borderBottomColor: "#3F3F3F",
  },
  topnameText: {
    color: "black",
    fontSize: "16px",
    fontWeight: "100",
    fontStyle: "normal",
    marginLeft: "10px",
    // fontFamily: 'kalamFont',
    marginBottom: "0px",
  },
  bottomnameText: {
    color: "black",
    fontSize: "8px",
    fontWeight: "100",
    fontStyle: "normal",
    marginTop: "3px",
    textTransform: "uppercase",
  },
  inspectionpointsText: {
    color: "black",
    fontSize: "15px",
    fontWeight: "700",
    fontStyle: "normal",
    marginTop: "25px",
  },
  passfailrowmainContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: "10px",

    justifyContent: "space-around",
    flex: "0 0 45%",
    marginRight: "10px",
  },

  dashedBorder: {
    width: "80px",
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "#959595",
    marginRight: "5px",
  },
  dashedBorder2: {
    width: "80px",
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "#959595",
    marginRight: "5px",
  },

  tickimgContainer: {
    width: "13px",
    height: "13px",
    borderWidth: 1,
    borderColor: "black",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "4px",
  },
  tickimgContainer2: {
    width: "13px",
    height: "13px",
    borderWidth: 1,
    borderColor: "black",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "4px",
  },
  emptytickimgContainer: {
    width: "13px",
    height: "13px",
    borderWidth: 1,
    borderColor: "black",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "8px",
  },
  emptytickimgContainer2: {
    width: "13px",
    height: "13px",
    borderWidth: 1,
    borderColor: "black",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "8px",
  },
  nameText: {
    color: "black",
    fontSize: "9px",
    fontWeight: "300",
    fontStyle: "normal",
    textTransform: "uppercase",
    width: "60%",
  },
  passText: {
    color: "#959595",
    fontSize: "11px",
    fontWeight: "700",
    fontStyle: "normal",
    textTransform: "uppercase",
    marginLeft: "5px",
  },
  failText: {
    color: "#959595",
    fontSize: "11px",
    fontWeight: "700",
    fontStyle: "normal",
    textTransform: "uppercase",
    marginLeft: "5px",
  },
  nameTextss: {
    color: "black",
    fontSize: "10px",
    fontWeight: "300",
    fontStyle: "normal",
    textTransform: "uppercase",
    marginLeft: "20px",
    width: "30%",
  },

  passTexts2: {
    color: "#959595",
    fontSize: "11px",
    fontWeight: "700",
    fontStyle: "normal",
    textTransform: "uppercase",
    marginLeft: "5px",
  },
  failTexts2: {
    color: "#959595",
    fontSize: "11px",
    fontWeight: "700",
    fontStyle: "normal",
    textTransform: "uppercase",
    marginLeft: "5px",
  },
  inspectionresultContainer: {
    width: "70%",
    backgroundColor: "#767170",
    padding: "10px",
    alignSelf: "center",
    marginTop: "30px",
  },
  inspectionrexultText: {
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "white",
    textAlign: "center",
  },
  inspectiondatemainContainer: {
    padding: "10px",
    backgroundColor: "#F7F7F7",
    width: "70%",
    alignSelf: "center",
  },
  markingText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "600",
    color: "#767170",
    textAlign: "center",
    marginTop: "5px",
  },
  passfaildatedirectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    marginTop: "30px",
    marginBottom: "15px",
  },
  boxBorder: {
    borderBottomStyle: "dashed",
    borderBottomWidth: 2,
    borderBottomColor: "black",
    width: "130%",
    letterSpacing: "10px",
  },
  boxpasscircleContainer: {
    width: "70px",
    height: "70px",
    borderWidth: 3,
    borderColor: "#000",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50px",
  },
  boxpassText: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "black",
  },
  boxdateText: {
    fontSize: "12px",
    color: "#767170",
    marginBottom: "3px",
    // fontFamily: 'kalamFont',
    fontWeight: "bold",
  },
  inspectiondateText: {
    fontSize: "12px",
    fontWeight: "300",
    color: "#767170",
    marginTop: "3px",
  },
  textDirection: {
    flexDirection: "column",
    alignItems: "center",
  },
  bottommainContainer: {
    backgroundColor: "#F7F7F7",
    padding: "10px",
    marginTop: "30px",
  },
  byvehicleText: {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#FF4A86",
    textTransform: "uppercase",
  },
  firstfourfieldsContainer: {
    flexDirection: "row",
    // alignItems: "center",
    marginTop: "15px",
    marginBottom: "10px",
    alignItems: "flex-end",
  },
  firstfourfieldsContainerTop: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: "25px",
    marginBottom: "5px",
  },
  bottomboxBorder: {
    borderBottomWidth: 1,
    borderColor: " #767170",
  },
  bottomboxtoptext: {
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "black",
    // fontFamily: 'kalamFont',
    marginLeft: "10px",
    marginBottom: "0px",
    textTransform: "uppercase",
  },
  bottomboxbootomText: {
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "black",
    textTransform: "uppercase",
    marginTop: "3px",
  },
  lastbottomText: {
    textAlign: "center",
    marginTop: "5px",
    fontSize: "10px",
    color: "#4F4F4F",
  },
  vehicleinspectiontopText: {
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "black",
  },
  imageWrapperCarePool: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
  },
});

function LyftCertificateAllOthers({
  firstHalfData,
  certificateData,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              {certificateData &&
                certificateData?.CompanyData?.name === "Carepool" ? (
                <View style={styles.imageWrapperCarePool}>
                  <Image style={{ width: "40%" }} source={CarepoolImg} />
                </View>
              ) : null}

              {certificateData &&
                certificateData?.CompanyData?.name === "Carepool" ? (
                <View style={styles.headerContainerCarePool}>
                  <Text style={styles.vehicleinspectiontopText}>
                    Vehicle Inspection
                  </Text>
                </View>
              ) : (
                <View style={styles.headerContainer}>
                  <View></View>
                  <Text style={styles.vehicleinspectiontopText}>
                    Vehicle Inspection
                  </Text>

                  <Image
                    style={{ width: "80px" }}
                    source={`${certificateData && certificateData?.CompanyData?.url
                      }?x-request=xhr`}
                  />
                </View>
              )}
              <View style={styles.tobecompletedContainer}>
                <Text style={styles.tobecompletedText}>
                  TO BE COMPLETED BY VEHICLE OPERATOR
                </Text>
              </View>
              <View style={styles.topfieldsmainContainer}>
                <View style={styles.namefiledsContainer}>
                  <View style={styles.firstField}>
                    <Text style={[styles.topnameText, handwritingStyle]}>
                      {certificateData ?
                        `${certificateData?.Username || ''} ${certificateData?.UserlastName || ''}`.trim()
                        : ''
                      }</Text>
                    <View style={styles.fieldBorder} />
                    <Text style={styles.bottomnameText}>FULL NAME</Text>
                  </View>
                  <View style={styles.secondfield}>
                    <Text style={[styles.topnameText, handwritingStyle]}>
                      {certificateData && certificateData?.Useremail}
                    </Text>
                    <View style={styles.fieldBorder2} />
                    <Text style={styles.bottomnameText}>EMAIL ADDRESS</Text>
                  </View>
                </View>

                <View style={styles.firstfourfieldsContainerTop}>
                  <View style={{ width: "35%", marginRight: "15px" }}>
                    <Text style={{ color: "#F7F7F7" }}>Testing</Text>
                    {/* <Image style={{ width: '100px', marginTop: -25, marginLeft: '50px' }} source={SignatureImage} /> */}
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>Signature</Text>
                  </View>
                  <View style={{ width: "20%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {moment(
                        new Date(
                          certificateData && certificateData?.reviewedDate
                        )
                      ).format("MM/DD/YYYY")}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>Date</Text>
                  </View>
                  <View style={{ width: "46%" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.Userphone}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>phone number</Text>
                  </View>
                </View>
              </View>
              {/* <Text style={styles.inspectionpointsText}>INSPECTION POINTS</Text> */}
              <View style={{ flexWrap: "wrap", flexDirection: "row" }}>
                {/* <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                  {firstHalfData &&
                    firstHalfData.map((data) => (
                      <View style={styles.passfailrowmainContainer}>
                        <Text style={styles.nameText}>{data.name} </Text>
                        <View style={styles.dashedBorder} />
                        {data.status === 1 || data.status === true ? (
                          <View style={{ flexDirection: 'row', marginRight: '10px' }}>
                            <View style={styles.tickimgContainer}>
                              <Image style={{ width: '15px' }} source={TicketImg} />
                            </View>
                            <Text style={styles.passText}>PASS</Text>
                          </View>
                        ) : (
                          <View style={{ flexDirection: 'row', marginRight: '16px' }}>
                            <View style={styles.emptytickimgContainer}></View>
                            <Text style={styles.passText}>PASS</Text>
                          </View>
                        )}

                        {data.status === 0 || data.status === false ? (
                          <View style={{ flexDirection: 'row' }}>
                            <View style={styles.tickimgContainer}>
                              <Image style={{ width: '15px' }} source={TicketImg} />
                            </View>
                            <Text style={styles.passText}>FAIL</Text>
                          </View>
                        ) : (
                          <View style={{ flexDirection: 'row' }}>
                            <View style={styles.emptytickimgContainer}></View>
                            <Text style={styles.passText}>FAIL</Text>
                          </View>
                        )}
                      </View>
                    ))}
                </View> */}

                <Image
                  style={{ width: "100%", marginLeft: -7, marginTop: "5px" }}
                  source={GeneralChecks}
                />
              </View>

              <View style={styles.inspectionresultContainer}>
                <Text style={styles.inspectionrexultText}>
                  VEHICLE INSPECTION RESULTS (Inspector To Circle)
                </Text>
              </View>
              <View style={styles.inspectiondatemainContainer}>
                <Text style={styles.markingText}>
                  Any markings on the “fail” side will automatically fail
                  inspection
                </Text>

                <View style={styles.passfaildatedirectionContainer}>
                  {certificateData &&
                    certificateData?.finalStatus === "pass" ? (
                    <View style={styles.boxpasscircleContainer}>
                      <Text style={styles.boxpassText}>PASS</Text>
                    </View>
                  ) : (
                    <Text style={styles.boxpassText}>PASS</Text>
                  )}

                  <View style={styles.textDirection}>
                    <Text style={[styles.boxdateText, handwritingStyle]}>
                      {certificateData?.reviewedDate
                        ? moment(certificateData?.reviewedDate).format("MM/DD/YYYY")
                        : ''
                      }

                    </Text>
                    <View style={styles.boxBorder} />
                    <Text style={styles.inspectiondateText}>
                      Inspection Date
                    </Text>
                  </View>
                  {certificateData &&
                    certificateData?.finalStatus === "fail" ? (
                    <View style={styles.boxpasscircleContainer}>
                      <Text style={styles.boxpassText}>FAIL</Text>
                    </View>
                  ) : (
                    <Text style={styles.boxpassText}>FAIL</Text>
                  )}
                </View>
              </View>
              <View style={styles.bottommainContainer}>
                <Text style={styles.byvehicleText}>
                  to be completed by vehicle inspector
                </Text>

                <View style={styles.firstfourfieldsContainer}>
                  <View style={{ width: "20%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.milage}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      Vehicle mileage
                    </Text>
                  </View>
                  <View style={{ width: "20%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.registrationState}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      license plate state
                    </Text>
                  </View>
                  <View style={{ width: "20%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.licensePlateNumber}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      License plate number
                    </Text>
                  </View>
                  <View style={{ width: "40%" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.vin}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>Vin</Text>
                  </View>
                </View>

                <View style={styles.firstfourfieldsContainer}>
                  <View style={{ width: "40%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.make}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>vehicle make</Text>
                  </View>
                  <View style={{ width: "22%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.model}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      vehicle model
                    </Text>
                  </View>
                  <View style={{ width: "18%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.year}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>vehicle year</Text>
                  </View>
                  <View style={{ width: "15%" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {certificateData && certificateData?.vehicleDoors}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      number of doors
                    </Text>
                  </View>
                </View>

                <View style={styles.firstfourfieldsContainer}>
                  <View style={{ width: "41%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>Chex Inc.</Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      inspector company
                    </Text>
                  </View>
                  <View style={{ width: "60%" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {`${certificateData && certificateData?.stateAddress}`}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      inspector address
                    </Text>
                  </View>
                </View>

                <View style={styles.firstfourfieldsContainer}>
                  <View style={{ width: "42%", marginRight: "15px" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>{certificateData ?
                      `${certificateData?.Username || ''} ${certificateData?.UserlastName || ''}`.trim()
                      : ''
                    }</Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      inspector name{" "}
                    </Text>
                  </View>
                  <View style={{ width: "30%", marginRight: "15px" }}>
                    {
                      certificateData && certificateData?.Inspectorsignature ? (
                        <Image
                          style={{
                            width: "80px",
                            marginLeft: "50px",
                            marginBottom: -11,
                          }}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${certificateData &&
                            certificateData?.Inspectorsignature
                            }`}
                        />
                      ) : null
                      // <Text style={[styles.bottomboxtoptext, handwritingStyle]}>{`${
                      //   certificateData && certificateData?.Inspectorname
                      // } ${
                      //   certificateData && certificateData?.InspectorlastName
                      // }`}</Text>
                    }
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      inspector signature
                    </Text>
                  </View>
                  <View style={{ width: "30%" }}>
                    <Text style={[styles.bottomboxtoptext, handwritingStyle]}>
                      {`${certificateData && certificateData?.stateNumber || ''}`}
                    </Text>
                    <View style={styles.bottomboxBorder} />
                    <Text style={styles.bottomboxbootomText}>
                      state certification number
                    </Text>
                  </View>
                </View>
              </View>
              <Text style={styles.lastbottomText}>
                This certification expires on (1) year from inspection date
              </Text>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const LyftCertificateAllOthersConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template3");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <LyftCertificateAllOthers
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.lyftVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setLyftReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LyftCertificateAllOthersConnected);
